import styled from 'styled-components';

export const StyledError = styled.span`
  color: red;
  min-height: 30px;
`;
